import React, { FC } from 'react'
import { Skeleton, Stack } from '@chakra-ui/react'

interface ISectionListSkeletonProps {
  numberOfListItems?: number
}

/**
 * SectionListSkeleton component used as a placeholder for the SectionList and
 * its SectionListItem children.
 */
export const SectionListSkeleton: FC<ISectionListSkeletonProps> = ({
  numberOfListItems = 1,
}) => (
  <Stack data-testid="section-list-container" paddingTop="2rem">
    {[...Array(numberOfListItems).keys()].map((item) => (
      <Skeleton
        data-testid="section-list-skeleton-item"
        height="4rem"
        key={item}
      />
    ))}
  </Stack>
)
